<style lang="scss" scoped>
.img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}


.pay-page {
  min-height: 100vh;
  background-color: #fff;
 
}
</style>

<template>
<div class="pay-page">

  <main-pay 
    :mount="mount" 
    :curSelect="payType"
    :showAliPay="false"
    :orderInfo="orderInfo"
    >
  </main-pay>

</div>
</template>

<script>
import MainPay from './components/main.vue'
import PayItem from './components/pay-item'
import { refreshNoOpenIdPage } from './utils/utils'
import { checkWeChatBrowser } from './utils/utils'

export default {
  components: {
    MainPay,
    PayItem,
  },
  data() {
    return {
      payType: 'wxpay',
      mount: 888,
      orderInfo: {}
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    initPage() {
      const { orderNo, payMount, code, state, appid = 'wx336439508d336e22', cashierId } = this.$route.query
      this.orderInfo = {
        orderNo,
        payMount,
        code,
        state,
        appId: appid,
        cashierId
      };
      const isWechatBrowser = checkWeChatBrowser()
      if (isWechatBrowser && !this.orderInfo.code) {
        const url = encodeURIComponent('http://' + window.location.hostname + '/wxredirect/index.html?refer=' + encodeURIComponent(window.location.href))
        refreshNoOpenIdPage({appid, url})
      }


    }
  }
}
</script>
